import React from 'react';

export const WidgetCard = ({ children, className = "", gradient = false, onClick, testId, isDark }) => (
  <div
    data-testid={testId}
    onClick={onClick}
    className={`relative rounded-3xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl
      ${gradient ? 'bg-gradient-to-br from-[#493986] via-[#6b5b9a] to-[#92a7e8]' : isDark ? 'bg-[#1a1a2e]/80 backdrop-blur-xl border border-white/10' : 'bg-white/80 backdrop-blur-xl border border-[#493986]/10 shadow-lg'}
      ${className}`}
  >
    {children}
  </div>
);

export default WidgetCard;
